import React from "react"
import Helmet from "react-helmet"

import Navbar from "../components/Navbar"
import ImageBar from "../components/ImageBar"
import Footer from "../components/Footer"
import "typeface-playfair-display"
import "typeface-roboto"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./all.scss"

const TemplateWrapper = ({ children }) => (
  <>
    <Helmet title="Fort Bend County MUD No. 24" />
    <Navbar />
    <ImageBar />
    {children}
    <Footer />
  </>
)

export default TemplateWrapper
